import { ModuleQuestionOutput } from 'module/model/page/question/module-question.output';
import { ModuleQuestion } from 'module/page/question/module-question';

export abstract class ModuleQuestionConverterPort {
	public abstract asModuleQuestion(output: ModuleQuestionOutput): ModuleQuestion;
}
